import type { BlockEvent, BlockEventHistory } from "@sperrdatei/dto/types";

export const isBlockEventHistoryItem = (
  value: BlockEvent | BlockEventHistory,
): value is BlockEventHistory => {
  return "created" in value;
};
